import React, { useState } from "react"
import { Grid, IconButton } from "@material-ui/core"
import { Link, useHistory } from "react-router-dom"

import {
	ArrowForwardIos as GoToConstructionIcon,
	Settings as SettingsIcon,
	FileCopy as DuplicateIcon,
	Publish as ExportIcon,
	Edit as EditIcon
} from "@material-ui/icons"

import { MoreOptionsMenu } from "@/components"
import { usePermissionStateStore } from "@/store/PermissionState"
import { PERMISSION_DENIED_MESSAGE } from "@/components/PermissionGate/BasePermissionGate"

import useStyles from "@/pages/Admin/Flow/FlowList/FlowListItem/FlowListItemButtons/styles"
import ErrorHandlerService from "@/services/ErrorHandler"
import { ErrorType } from "@/hooks/useValidation"

import ChatBotFlowService from "@/services/ChatBotFlow"
import ChatBotConfig from "@/pages/Admin/ChatBot/ChatBotList/ChatBotConfig"

type FlowListButtonsProps = {
	onExport: () => Promise<void> | void
	onEdit: () => void
	flowEditorPath: string
	chatBotFlow: {
		id: number
		name: string
	}
}

const FlowListItemButtons: React.FC<FlowListButtonsProps> = (props) => {
	const {
		onEdit,
		onExport,
		flowEditorPath,
		chatBotFlow
	} = props
	const { checkPermission } = usePermissionStateStore()

	const [chatBotConfigFlowId, setChatBotConfigFlowId] = useState<number | null>(null)

	const classes = useStyles()

	const history = useHistory()

	const handleDuplicateChatBot = async () => {
		try {
			const duplicatedChatBotFlow = await ChatBotFlowService.duplicate(chatBotFlow.id)

			history.push(`/admin/automation/flow/${duplicatedChatBotFlow.id}`)
		} catch (error) {
			ErrorHandlerService.handle(error as ErrorType)
		}
	}

	const handleChangeChatBotConfig = () => {
		setChatBotConfigFlowId(chatBotFlow.id)
	}

	const optionsMenu = () => {
		const options = [
			{
				title: "Duplicar Bot",
				icon: <DuplicateIcon />,
				showIcon: true,
				disabled: !checkPermission("chat-bot", "duplicate"),
				disabledTooltip: PERMISSION_DENIED_MESSAGE,
				onClick: handleDuplicateChatBot
			},
			{
				title: "Alterar Nome",
				icon: <EditIcon />,
				showIcon: true,
				disabled: !checkPermission("chat-bot", "update"),
				disabledTooltip: PERMISSION_DENIED_MESSAGE,
				onClick: onEdit
			},
			{
				title: "Configurações",
				icon: <SettingsIcon />,
				showIcon: true,
				onClick: handleChangeChatBotConfig
			},
			{
				title: "Exportar Fluxo",
				showIcon: true,
				icon: <ExportIcon />,
				disabled: !checkPermission("chat-bot", "export"),
				disabledTooltip: PERMISSION_DENIED_MESSAGE,
				onClick: onExport
			}
		]

		return options
	}

	return (
		<Grid container spacing={1} justifyContent="flex-end">
			<Grid item md={12} lg="auto">
				<Grid container alignItems="center" justifyContent="flex-end">
					<Link
						to={flowEditorPath}
						style={{ textDecoration: "none" }}
						target="_blank"
					>
						<IconButton className={classes.listItemButton}>
							<GoToConstructionIcon className={classes.editIcon} />
						</IconButton>
					</Link>
				</Grid>
			</Grid>

			<Grid item md={12} lg="auto">
				<Grid className={classes.listItemMoreOptions}>
					<MoreOptionsMenu options={optionsMenu()} />
				</Grid>
			</Grid>

			{chatBotConfigFlowId !== null && (
				<ChatBotConfig
					chatBotFlowId={chatBotConfigFlowId}
					title="CONFIGURAÇÕES DO BOT"
					openDialog={true}
					onClose={() => setChatBotConfigFlowId(null)}
				/>
			)}
		</Grid>
	)
}

export default FlowListItemButtons
